export const itemType = Object.freeze({
	product: 'product',
	medicine: 'medicine'
});
